import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CaseServiceService } from 'src/app/modules/case/case-service.service';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-comments-listing',
  templateUrl: './comments-listing.component.html',
  styleUrl: './comments-listing.component.css'
})
export class CommentsListingComponent {

  @Input() alertDetails: any;
  @Input() isCollapsed: boolean;
  @Input() commentsList: any;
  @Output() collapse = new EventEmitter<any>();

  comment = new FormControl();

  constructor(public service: ServicecallService, private _caseService: CaseServiceService, private _sharedService: ServicecallService) { }

  /**
   * Handles close
   * @param isClosed 
   */
  handleClose(isClosed: boolean) {
    this.collapse.emit(isClosed);
  }

  /**
 * Saves comment
 */
  saveComment() {
    const reqPayload = {
      module: 'events',
      commentText: this.comment?.value,
      moduleId: this.alertDetails?.id
    }
    this._caseService?.addComments(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.comment?.reset();
            this.handleClose(true);
            this._sharedService.toasterService({
              type: 'success',
              msg: 'Comment added successfully',
            });
          }
        }, error: (error: any) => {
          this._sharedService.toasterService({
            type: 'error',
            msg: 'Unable to add comment',
          });
        }
      });
  }
}
